import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import MoreIconContainer from 'common/components/atoms/MoreIconContainer';
import MoreIcon from 'common/images/MoreIconSvg';
import InlineModal from 'common/components/molecules/InlineModal';
import OutsideAlerter from 'common/OutsideAlerter';
import { connect } from 'react-redux';

// Assets filter bars sit above the default side rail; lift menus only on that page.
const ASSETS_MENU_Z_INDEX = 200;

class MoreOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemMenuOpen: false
    };
  }

  render() {
    const partner = this.props.partner;
    const primaryColor = partner.theme.primaryColor;
    const greyColor = partner.theme.grey;
    const { itemMenuOpen } = this.state;
    const onAssetsPage = this.props.location && this.props.location.pathname === '/assets';
    const menuZIndex = onAssetsPage ? ASSETS_MENU_Z_INDEX : this.props.zIndex;
    return (
      <MoreIconContainer
        {...this.props}
        zIndex={itemMenuOpen ? menuZIndex : this.props.zIndex}
        onClick={(e) => { this.setState({ itemMenuOpen: true }); e.stopPropagation(); }}
      >
        <MoreIcon fill={itemMenuOpen ? primaryColor : greyColor} width={this.props.iconWidth} />
        {itemMenuOpen && (
          <InlineModal
            width={this.props.inlineWidth}
            noOverlay
            minWidthInline={this.props.minWidthInline}
            marginTop="5px"
            noScroll
            zIndex={menuZIndex}
            close={() => this.setState({ itemMenuOpen: false })}
          >
            <OutsideAlerter event="click" open handleClick={() => this.setState({ itemMenuOpen: false })}>
              <div onClick={(e) => { this.setState({ itemMenuOpen: false }); e.stopPropagation(); }}>
                {this.props.children}
              </div>
            </OutsideAlerter>
          </InlineModal>
        )}
      </MoreIconContainer>
    );
  }
}

MoreOptions.propTypes = {
  iconWidth: PropTypes.number,
  minWidthInline: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

MoreOptions.defaultProps = {
  iconWidth: 16,
  minWidthInline: '120px',
  zIndex: undefined
};

const mapStateToProps = state => ({
  partner: state.companyReducer.partner
});
export default withRouter(connect(mapStateToProps)(MoreOptions));
